import { createContext, useContext } from 'react'

import type { BlueprintBindings } from '../../blueprint-bindings'

export const BlueprintBindingsContext = createContext<BlueprintBindings>({
  bindingValues: {},
  bindingHandlers: {},
})

export function useBlueprintBindings(): BlueprintBindings {
  return useContext(BlueprintBindingsContext)
}
